import React from "react";
import {
  Code2,
  CreditCard,
  Headphones,
  Landmark,
  Network,
  ShieldCheck,
} from "lucide-react";
import { useLanguage } from "../../i18n/LanguageProvider";
import RevealOnScroll from "../RevealOnScroll";

const trustItems = [
  { icon: Landmark, label: "Agrément Banque Centrale du Congo" },
  { icon: Network, label: "Agrégation Mobile Money" },
  { icon: Code2, label: "API de paiement" },
  { icon: CreditCard, label: "Solutions monétiques" },
  { icon: Headphones, label: "Assistance à l’intégration" },
  { icon: ShieldCheck, label: "Paiements sécurisés" },
];

const HomeTrustBar = () => {
  const { t } = useLanguage();

  return (
    <section
      className="ws-home-trust-bar"
      aria-label={t("Nos engagements de confiance")}
    >
      <div className="ws-shell ws-home-trust-bar__grid">
        {trustItems.map(({ icon: Icon, label }, index) => (
          <RevealOnScroll
            as="div"
            className="ws-home-trust-bar__item"
            delay={index * 70}
            key={label}
          >
            <Icon size={19} aria-hidden="true" />
            <span>{t(label)}</span>
          </RevealOnScroll>
        ))}
      </div>
    </section>
  );
};

export default HomeTrustBar;
